export const IS_MOBILE = "IS_MOBILE";
